import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import FloatingLabelInput from "./PlaceHolder";
import { RESTAURANT_API_PATHS } from "../constants/apiPaths";
import axiosRestaurantInstance from "./AxiosRestaurantInstance";

import "./css/PasswordReset.css";

import logo from "./assets/myeats-logo.png";
import bike from "./assets/bike.png";
import restaurant from "./assets/Restaurant.png";
import children from "./assets/children.png";

function UnnoticedPassword() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const nextStep = () => setStep((prevStep) => prevStep + 1);
  // const prevStep = () => setStep((prevStep) => prevStep - 1);

  const handleEmailSubmit = async (email) => {
    setEmail(email);
    setLoading(true);
    setError(null);
    try {
      const response = await axiosRestaurantInstance.post(RESTAURANT_API_PATHS.restaurantsRequest, {
        identifier: email,
        purpose: "forgotpassword"
      });
      if (response.status === 200) {
        nextStep();
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to send verification code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ""); // Allow only numbers
    const newOtp = [...otp];

    if (value === "") {
      // Clear current box and move to the previous box if backspace
      newOtp[index] = "";
      setOtp(newOtp);

      if (element.previousSibling) {
        element.previousSibling.focus();
      }
    } else if (value.length === 1) {
      // Update the current box
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next box if available
      if (element.nextSibling) {
        element.nextSibling.focus();
      }
    } else {
      // If user pastes more than one character, ignore the input
      element.value = otp[index];
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index]) {
      // If the current box is empty and backspace is pressed, move to the previous box
      if (event.target.previousSibling) {
        event.target.previousSibling.focus();
      }
    }
  };

  const handleResendOtp = async () => {
    console.log("Resend OTP clicked");
    setLoading(true);
    setError(null);
    try {
      const response = await axiosRestaurantInstance.post(RESTAURANT_API_PATHS.restaurantsRequest, {
        identifier: email,
      });
      if (response.status === 200) {
        setError(null);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to resend verification code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const enteredOtp = otp.join("");
    console.log("Entered OTP:", enteredOtp);

    setLoading(true);
    setError(null);

    try {
      const response = await axiosRestaurantInstance.post(RESTAURANT_API_PATHS.restaurantsVerify, {
        identifier: email,
        otp: enteredOtp,
      });

      if (response.status === 200) {
        setError(null); // Clear any previous error
        nextStep(); // Move to case 3
      } else {
        setError(response.data.message || "OTP verification failed.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async () => {
    setLoading(true);
    setError(null);

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosRestaurantInstance.post(RESTAURANT_API_PATHS.restaurantsResetPassword, {
        email: email,
        newPassword: confirmPassword,
      });

      if (response.status === 200) {
        setError(null);
        navigate("/restaurant/signin");
      } else {
        setError(response.data.message || "Password reset failed.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Password reset failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleEmailSubmit(email);
            }}
            className="form-container"
          >
            {error && <div className="error-message">{error}</div>}
            <h3 className="forgot_heading" style={{ marginBottom: "8px" }}>
              Restaurant
            </h3>
            <div className="forgot-form-group1">
              <FloatingLabelInput
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label="Enter your email"
                isRequired={true}
              />
            </div>

            <button type="submit" className="forgot_button1">
              Submit
            </button>
            <div className="forgot_case1_link">
              Remembered Password?{" "}
              <a href="/restaurant/signin" className="forgot_link">
                Sign In
              </a>
            </div>
          </form>
        );
      case 2:
        return (
          <form onSubmit={handleOtpSubmit} className="otp-form-container">
            <p className="otp-instruction">Enter the OTP sent to your email</p>

            {/* OTP Input Boxes */}
            <div className="otp-box-container">
              {otp.map((value, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="otp-box"
                  value={value}
                  onChange={(e) => handleChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)} // New handler for backspace
                  onFocus={(e) => e.target.select()} // Select content on focus
                />
              ))}
            </div>

         
              <button type="submit" className="otp-verify-button">
                Verify OTP
              </button>

              <p className="otp-resend-text">
                Didn't receive the OTP?{" "}
                <button
                  type="button"
                  className="otp-resend-link"
                  onClick={handleResendOtp}
                >
                  Resend OTP
                </button>
              </p>
      
          </form>
        );
      case 3:
        return (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handlePasswordSubmit();
            }}
            className="form-container"
          >
            {error && <div className="error-message">{error}</div>}
            <h3 className="forgot_heading2">Restaurant</h3>
            <div
            // className="forgot_password-form-group" 
            className="forgot-form-group1"
            >
              <FloatingLabelInput
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                label="Create a new password"
                isRequired={true}
              />
            </div>
            <div 
            // className="forgot_password-form-group"
            className="forgot-form-group1"

            >
              <FloatingLabelInput
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                label="Confirm your password"
                isRequired={true}
              />
            </div>
            {/* <div className="forgot_password-form-group"> */}
              <button type="submit"
            //    className="forgot_savebutton"
               className="forgot_button1"
               >
                Save
              </button>
            {/* </div> */}
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-left-section">
        <img src={children} alt="Children" className="forgot-children" />
        <img 
        src={restaurant}
         alt="Restaurant" 
         className="forgot-restaurant" />
         
        <img src={bike} alt="Bike" className="forgot-bike" />
      </div>
      <div className="forgot-right-section">
        <div className="forgot-logo">
          <img src={logo} alt="My Eats" />
        </div>

        {loading && <div className="loading-spinner">Loading...</div>}
        {renderStep()}
      </div>
    </div>
  );
}

export default UnnoticedPassword;
